import supplierService from '@/api/supplier'
import {SUPPLIER} from '@/store/types'
import strings from '@/strings'

export default {
  namespaced: true,
  state: {
    suppliers: [],
    items: [],
    itemType: '',
    supplierName: ''
  },
  mutations: {
    [SUPPLIER.SET_SUPPLIERS] (state, suppliers) {
      state.suppliers = suppliers
    },
    [SUPPLIER.SET_ITEMS] (state, items) {
      state.items = items
    },
    [SUPPLIER.SET_ITEM_TYPE] (state, itemType) {
      state.itemType = itemType
    },
    [SUPPLIER.SET_NAME] (state, name) {
      state.supplierName = name
    }
  },
  actions: {
    async getSupplierList ({commit, dispatch}) {
      try {
        let response = await supplierService.getSuppliers()
        commit(SUPPLIER.SET_SUPPLIERS, response.data)
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async activateSupplier ({dispatch}, supplierId) {
      try {
        await supplierService.activateSupplier(supplierId)
        dispatch('getSupplierList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async deactivateSupplier ({dispatch}, supplierId) {
      try {
        await supplierService.deactivateSupplier(supplierId)
        dispatch('getSupplierList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async addSupplier ({dispatch}, supplier) {
      try {
        await supplierService.addSupplier(supplier)
        dispatch('getSupplierList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async editSupplier ({dispatch}, supplier) {
      try {
        await supplierService.editSupplier(supplier.id, supplier)
        dispatch('getSupplierList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async getItemsList ({state, commit, dispatch}) {
      try {
        let response = await supplierService.getItems(state.itemType)
        commit(SUPPLIER.SET_ITEMS, response.data)
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
      async activateSupplierItem ({state, dispatch}, payload) {
      try {
        let params = {
          itemType: state.itemType,
          serviceId: payload.itemId
        }
        await supplierService.activateSupplierItem(params)
        dispatch('getItemsList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async deactivateSupplierItem ({state, dispatch}, payload) {
      try {
        let params = {
          itemType: state.itemType,
          serviceId: payload.itemId
        }
        await supplierService.deactivateSupplierItem(params)
        dispatch('getItemsList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async addSupplierItem ({state, dispatch}, payload) {
      try {
        let params = {
          itemType: state.itemType
        }
        await supplierService.addSupplierItem(params, payload.item)
        dispatch('getItemsList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    async editSupplierItem ({state, dispatch}, payload) {
      try {
        let params = {
          itemType: state.itemType,
          serviceId: payload.itemId
        }
        await supplierService.editSupplierItem(params, payload.item)
        dispatch('getItemsList')
      }
      catch (error) {
        dispatch('Global/hideLoading', null, { root: true })
        return Promise.reject(error)
      }
    },
    setItemTypeByRoute ({commit}, routeName) {
      const itemType = (routeName) => {
        switch (routeName) {
          case 'SupplierFoods':
            return strings.supplierItemsTypePlural.food
          case 'SupplierEquipments':
            return strings.supplierItemsTypePlural.equipment
        }
      }
      commit(SUPPLIER.SET_ITEM_TYPE, itemType(routeName))
    },
    setSupplierName ({commit}, name) {
      commit(SUPPLIER.SET_NAME, name)
    }
  }
}
